"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");
var _getElementType = _interopRequireDefault(require("@instructure/ui-utils/lib/react/getElementType"));
var _hasVisibleChildren = _interopRequireDefault(require("@instructure/ui-a11y/lib/utils/hasVisibleChildren"));
var _theme = _interopRequireDefault(require("./theme"));
var _dec, _class, _class2, _temp;
var styles = {
  componentId: 'fCrpb',
  template: function template(theme) {
    return "\n\n.fCrpb_bGBk,.fCrpb_bGBk.fCrpb_fVUh,label.fCrpb_bGBk{all:initial;animation:none 0s ease 0s 1 normal none running;backface-visibility:visible;background:transparent none repeat 0 0/auto auto padding-box border-box scroll;border:medium none currentColor;border-collapse:separate;border-image:none;border-radius:0;border-spacing:0;bottom:auto;box-shadow:none;box-sizing:content-box;caption-side:top;clear:none;clip:auto;color:#000;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-span:1;column-width:auto;columns:auto;content:normal;counter-increment:none;counter-reset:none;cursor:auto;direction:ltr;display:inline;display:block;empty-cells:show;float:none;font-family:serif;font-size:medium;font-stretch:normal;font-style:normal;font-variant:normal;font-weight:400;height:auto;hyphens:none;left:auto;letter-spacing:normal;line-height:normal;list-style:disc outside none;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;orphans:2;outline:medium none invert;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;position:static;right:auto;tab-size:8;table-layout:auto;text-align:left;text-align-last:auto;text-decoration:none;text-indent:0;text-shadow:none;text-transform:none;top:auto;transform:none;transform-origin:50% 50% 0;transform-style:flat;transition:none 0s ease 0s;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:2;width:auto;word-spacing:normal;z-index:auto}\n\n.fCrpb_bGBk.fCrpb_fVUh{display:table;width:100%}\n\n.fCrpb_egrg,.fCrpb_egrg.fCrpb_fVUh,label.fCrpb_egrg{color:".concat(theme.color || 'inherit', ";font-family:").concat(theme.fontFamily || 'inherit', ";font-size:").concat(theme.fontSize || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";margin:0;text-align:inherit}\n\n[dir=ltr] .fCrpb_egrg,[dir=ltr] .fCrpb_egrg.fCrpb_fVUh,[dir=ltr] label.fCrpb_egrg,[dir=rtl] .fCrpb_egrg,[dir=rtl] .fCrpb_egrg.fCrpb_fVUh,[dir=rtl] label.fCrpb_egrg{text-align:inherit}");
  },
  'root': 'fCrpb_bGBk',
  'legend': 'fCrpb_fVUh',
  'has-content': 'fCrpb_egrg'
};
var FormFieldLabel = (
/**
---
parent: FormField
---

This is a helper component that is used by most of the custom form
components. In most cases it shouldn't be used directly.

```js
---
example: true
---
<FormFieldLabel>Hello</FormFieldLabel>
```

**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FormFieldLabel, _Component);
  function FormFieldLabel() {
    (0, _classCallCheck2.default)(this, FormFieldLabel);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormFieldLabel).apply(this, arguments));
  }
  (0, _createClass2.default)(FormFieldLabel, [{
    key: "render",
    value: function render() {
      var _classes;
      var ElementType = (0, _getElementType.default)(FormFieldLabel, this.props);
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles['has-content'], (0, _hasVisibleChildren.default)(this.props.children)), _classes);
      return _react.default.createElement(ElementType, Object.assign({}, (0, _passthroughProps.omitProps)(this.props, FormFieldLabel.propTypes), {
        className: (0, _classnames.default)(classes)
      }), this.props.children);
    }
  }]);
  FormFieldLabel.displayName = "FormFieldLabel";
  return FormFieldLabel;
}(_react.Component), _class2.propTypes = {
  as: _propTypes.default.elementType,
  children: _propTypes.default.node.isRequired
}, _class2.defaultProps = {
  as: 'span'
}, _temp)) || _class);
exports.default = FormFieldLabel;